import type { ToastEntry } from './ToastProvider'

interface ToastProps {
  toast: ToastEntry
  onDismiss: (id: string) => void
}

export function Toast({ toast, onDismiss }: ToastProps) {
  return (
    <div className={`toast toast--${toast.variant}`} role="status">
      <span className="toast__message">{toast.message}</span>
      <button
        type="button"
        className="toast__dismiss"
        onClick={() => {
          onDismiss(toast.id)
        }}
        aria-label="Dismiss notification"
      >
        &times;
      </button>
    </div>
  )
}
